<script>
    import TextArrow from "../../Components/TextArrow/TextArrow.svelte";
    import Person from "../../Components/Person/Person.svelte";
    import pattern_2 from "../../../public/src/svg/Patterns/pattern_2.svelte";

    let persons = [
        {
            image: "https://sun9-25.userapi.com/impg/VYrRJinHu0qODbEgTuofCQcAfR95aqq0upmNkw/24E564Qv5zM.jpg?size=604x604&quality=95&sign=b81f945387d93ad3987b9e41153fef3f&type=album",
            name: "Данил Чаюн",
            post: "Президент Федерации",
            link: "https://vk.com/dvchayun",
        },
        {
            image: "https://sun9-75.userapi.com/impg/0kAdox8EuURfS4AZvcoB8PliU4JUwhZUVnCutA/f3IAn7upmek.jpg?size=604x604&quality=95&sign=4b5a9f0e9baf35b3e7e35a585f699a13&type=album",
            name: "Денис Степанчук",
            post: "Вице-президент",
            link: "https://vk.com/denistgu",
        },
        {
            image: "https://sun9-55.userapi.com/impg/Zz3Givd2F5AzAWvp4TO0DAA9Mvn_RqXw0B0HSQ/qZ9tbhsuPbc.jpg?size=604x604&quality=95&sign=7891016c9d44ae8db9c444b50e9a7aec&type=album",
            name: "Валерий Лешехва",
            post: "Вице-президент",
            link: "https://vk.com/valera_dsgo",
        },
        {
            image: "https://sun9-31.userapi.com/impg/tnoiQEG0QO4LWp_lomOKWeDdqmTtF9iPgj2xrA/U82WayXA67M.jpg?size=604x604&quality=95&sign=27d8589a5219595df80630a46cd17aa6&type=album",
            name: "Илья Толстов",
            post: "Вице-президент",
            link: "https://vk.com/tolstoviv",
        },
        {
            image: "https://sun9-48.userapi.com/impg/xt9WIs3PFbc3-x0c3NELl2sm3tjQG83SvNJVyQ/tQ4PBaoyxSM.jpg?size=604x604&quality=95&sign=446f034724c4e0b9d279880fd9f72cf2&type=album",
            name: "Павел Вешкурцев",
            post: "Исполнительный директор",
            link: "https://vk.com/pavel707r",
        },
    ];
</script>

<div id="content">
    <div class="pattern-block" style="margin-bottom: 20px;">
        <div class="pattern">
            <svelte:component this={pattern_2} />
        </div>
    </div>
    <TextArrow showArrow={false} text={"Федерация Фиджитал Спорта"} />
    <div class="text">
        <p>
            Наименование — Региональная физкультурно-спортивная общественная
            организация «Федерация фиджитал спорта (функционально-цифрового
            спорта) Тюменской области».
        </p>
        <p>
            Сокращенное наименование – РФСОО «Федерация фиджитал спорта
            Тюменской области».
        </p>
        <img
            src="https://sun9-37.userapi.com/impg/iIUGeP2aSuUCAck4f8QG7nRzHs4jKEK9u_7INw/rqcDq1MikXo.jpg?size=1920x720&quality=96&sign=8bd6cf886caa6d3de4466d47abf11465&type=album"
            alt=""
        />
        <p>
            Фиджитал спорт (Physical + Digital) – объединение физического и
            цифрового – это та реальность, в которой давно живёт современный
            мир. И спорт не исключение. Даже самые консервативные виды спорта,
            которые десятилетиями придерживаются традиционного уклада, не
            пренебрегают инновациями и становятся более технологичными.
        </p>

        <p>
            Цель федерации — поддержка и популяризация фиджитал-спорта в
            Тюменской области с целью развития «гармоничного человека», который
            силен как в цифровом, так и в физическом пространствах.
        </p>
    </div>

    <div class="pattern-block" style="margin-bottom: 20px;">
        <div class="pattern">
            <svelte:component this={pattern_2} />
        </div>
    </div>
    <TextArrow showArrow={false} text={"Руководство федерации"} />


    <div class="container">
        <div class="persons">
            {#each persons as person}
                <Person person={person}></Person>
            {/each}
        </div>
    </div>

</div>

<style lang="less" global>
    @import "about.less";
</style>
